module.exports = __webpack_public_path__ + "static/media/avatar-1.e4dab0e2.jpg";